import BadgeOutlined from '@mui/icons-material/BadgeOutlined';
import CardGiftcardOutlined from '@mui/icons-material/CardGiftcardOutlined';
import CategoryOutlined from '@mui/icons-material/CategoryOutlined';
import ConfirmationNumberOutlined from '@mui/icons-material/ConfirmationNumberOutlined';
import DashboardOutlined from '@mui/icons-material/DashboardOutlined';
import AssessmentOutlined from '@mui/icons-material/AssessmentOutlined';
import DescriptionOutlined from '@mui/icons-material/DescriptionOutlined';
import ExtensionOutlined from '@mui/icons-material/ExtensionOutlined';
import GroupsOutlined from '@mui/icons-material/GroupsOutlined';
import HealthAndSafetyOutlined from '@mui/icons-material/HealthAndSafetyOutlined';
import LayersOutlined from '@mui/icons-material/LayersOutlined';
import LocalOfferOutlined from '@mui/icons-material/LocalOfferOutlined';
import MedicalServicesOutlined from '@mui/icons-material/MedicalServicesOutlined';
import MenuIcon from '@mui/icons-material/Menu';
import NotificationsOutlined from '@mui/icons-material/NotificationsOutlined';
import PeopleOutlined from '@mui/icons-material/PeopleOutlined';
import PersonOutlined from '@mui/icons-material/PersonOutlined';
import PetsOutlined from '@mui/icons-material/PetsOutlined';
import PsychologyOutlined from '@mui/icons-material/PsychologyOutlined';
import ReceiptLongOutlined from '@mui/icons-material/ReceiptLongOutlined';
import SettingsOutlined from '@mui/icons-material/SettingsOutlined';
import SmartphoneOutlined from '@mui/icons-material/SmartphoneOutlined';
import StorefrontOutlined from '@mui/icons-material/StorefrontOutlined';
import HubOutlined from '@mui/icons-material/HubOutlined';
import SyncOutlined from '@mui/icons-material/SyncOutlined';
import AccountBalanceWalletOutlined from '@mui/icons-material/AccountBalanceWalletOutlined';
import KeyboardArrowDown from '@mui/icons-material/KeyboardArrowDown';
import LogoutOutlined from '@mui/icons-material/LogoutOutlined';
import WebhookOutlined from '@mui/icons-material/WebhookOutlined';
import { AppBar, ButtonBase, ListItemIcon, ListItemText, Toolbar, useMediaQuery } from '@mui/material';
import { alpha } from '@mui/material/styles';
import Avatar from '@mui/material/Avatar';
import Box from '@mui/material/Box';
import Divider from '@mui/material/Divider';
import Drawer from '@mui/material/Drawer';
import IconButton from '@mui/material/IconButton';
import List from '@mui/material/List';
import ListItemButton from '@mui/material/ListItemButton';
import ListSubheader from '@mui/material/ListSubheader';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import Typography from '@mui/material/Typography';
import { useState } from 'react';
import { Link, Navigate, Outlet, useLocation, useNavigate } from 'react-router-dom';
import Logo from '../../assets/logo.png';
import Dropdown from '../../components/Dropdown';
import { LoadingContent } from '../../components/Loading';
import { useAuth } from '../../context/AuthContext';
import HelpSidebarProvider from '../../context/HelpSidebarContext';
import { getStoredUser, isAdminUser } from '../../services/authSession';

const DRAWER_WIDTH = 260;

const DASHBOARD_ITEM = { label: 'Dashboard', to: '/dashboard', end: true, icon: DashboardOutlined };

const NAV_GROUPS = [
    {
        label: 'Descontos e Cashback',
        items: [
            { label: 'Anunciantes', to: '/dashboard/anunciantes', icon: StorefrontOutlined },
            { label: 'Ofertas', to: '/dashboard/ofertas', icon: LocalOfferOutlined },
            { label: 'Resgates', to: '/dashboard/resgates', icon: ConfirmationNumberOutlined },
            { label: 'Cashback', to: '/dashboard/cashback', icon: AccountBalanceWalletOutlined },
            { label: 'Lomadee — Fila', to: '/dashboard/brokers/lomadee/fila', icon: SyncOutlined },
            { label: 'Awin — Fila', to: '/dashboard/brokers/awin/fila', icon: HubOutlined },
        ],
    },
    {
        label: 'Clubes',
        items: [
            { label: 'Visão geral', to: '/dashboard/clubes/visao-geral', end: true, icon: AssessmentOutlined },
            {
                label: 'Clubes',
                to: '/dashboard/clubes',
                icon: GroupsOutlined,
                match: pathname => pathname === '/dashboard/clubes' || /^\/dashboard\/clubes\/\d+/.test(pathname),
            },
            { label: 'Assinantes', to: '/dashboard/assinantes', icon: PeopleOutlined },
            { label: 'Aplicativo', to: '/dashboard/aplicativo', icon: SmartphoneOutlined },
            { label: 'Notificações', to: '/dashboard/notificacoes', icon: NotificationsOutlined },
        ],
    },
    {
        label: 'Provedores',
        items: [
            { label: 'Telemedicina', to: '/dashboard/providers/telemedicina', icon: MedicalServicesOutlined },
            { label: 'Telepsicologia', to: '/dashboard/providers/telepsicologia', icon: PsychologyOutlined },
            { label: 'Seguro de vida', to: '/dashboard/providers/seguro', icon: HealthAndSafetyOutlined },
            { label: 'Telepet', to: '/dashboard/providers/telepet', icon: PetsOutlined },
        ],
    },
    {
        label: 'Vendas',
        items: [
            { label: 'Visão geral', to: '/dashboard/vendas', end: true, icon: AssessmentOutlined },
            { label: 'Propostas', to: '/dashboard/propostas', icon: DescriptionOutlined },
        ],
    },
    {
        label: 'Financeiro',
        items: [
            { label: 'Visão geral', to: '/dashboard/financeiro', end: true, icon: AssessmentOutlined },
            { label: 'Assinaturas', to: '/dashboard/assinaturas', icon: ReceiptLongOutlined },
            { label: 'Benefícios', to: '/dashboard/beneficios', icon: CardGiftcardOutlined },
        ],
    },
    {
        label: 'Configurações',
        items: [
            { label: 'Usuários', to: '/dashboard/configuracoes/usuarios', icon: PersonOutlined },
            { label: 'Cargos', to: '/dashboard/configuracoes/cargos', icon: BadgeOutlined },
            { label: 'Categorias', to: '/dashboard/configuracoes/categorias', icon: CategoryOutlined },
            { label: 'Adicionais', to: '/dashboard/configuracoes/adicionais', icon: ExtensionOutlined },
            { label: 'Planos', to: '/dashboard/configuracoes/planos', icon: LayersOutlined },
            { label: 'Webhook Asaas', to: '/dashboard/configuracoes/webhooks', icon: WebhookOutlined },
            { label: 'Parâmetros', to: '/dashboard/configuracoes/settings', icon: SettingsOutlined },
        ],
    },
];

function isNavActive(pathname, item) {
    if (typeof item.match === 'function') return item.match(pathname);
    if (item.end) {
        return pathname === item.to || pathname === `${item.to}/`;
    }
    return pathname === item.to || pathname.startsWith(`${item.to}/`);
}

function userInitials(user) {
    const raw = String(user?.userName || '').trim();
    if (!raw) return '?';
    if (raw.includes('@')) return raw[0].toUpperCase();
    const parts = raw.split(/\s+/).filter(Boolean);
    if (parts.length >= 2) return `${parts[0][0]}${parts[1][0]}`.toUpperCase();
    return raw.slice(0, 2).toUpperCase();
}

function userLabel(user) {
    const raw = String(user?.userName || '').trim();
    if (raw.includes('@')) return raw.split('@')[0];
    return raw || 'Conta';
}

function UserMenu({ user, navigate, LogOut }) {
    const roleLabel = user?.Team?.name || user?.role || null;

    return (
        <Dropdown>
            <ButtonBase
                aria-label="Abrir menu da conta"
                sx={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: 1,
                    pl: 0.5,
                    pr: 0.75,
                    py: 0.5,
                    borderRadius: 8,
                    color: 'inherit',
                    bgcolor: 'rgba(255,255,255,0.12)',
                    transition: 'background-color 0.15s',
                    '&:hover': { bgcolor: 'rgba(255,255,255,0.22)' },
                }}
            >
                <Avatar
                    sx={{
                        width: 32,
                        height: 32,
                        fontSize: 13,
                        fontWeight: 700,
                        bgcolor: 'rgba(255,255,255,0.28)',
                        color: 'inherit',
                    }}
                >
                    {userInitials(user)}
                </Avatar>
                <Box sx={{ minWidth: 0, textAlign: 'left', display: { xs: 'none', sm: 'block' } }}>
                    <Typography variant="body2" noWrap fontWeight={700} lineHeight={1.2} maxWidth={160}>
                        {userLabel(user)}
                    </Typography>
                    {roleLabel ? (
                        <Typography variant="caption" noWrap sx={{ opacity: 0.75, display: 'block', lineHeight: 1.2 }}>
                            {roleLabel}
                        </Typography>
                    ) : null}
                </Box>
                <KeyboardArrowDown sx={{ fontSize: 18, opacity: 0.8, display: { xs: 'none', sm: 'block' } }} />
            </ButtonBase>
            <Menu
                anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
                transformOrigin={{ vertical: 'top', horizontal: 'right' }}
                slotProps={{ paper: { sx: { minWidth: 220, mt: 1 } } }}
            >
                <Box sx={{ px: 2, py: 1.25 }}>
                    <Typography variant="body2" fontWeight={700} noWrap>
                        {user?.userName}
                    </Typography>
                    {roleLabel ? (
                        <Typography variant="caption" color="text.secondary">
                            {roleLabel}
                        </Typography>
                    ) : null}
                </Box>
                <Divider />
                <MenuItem onClick={() => navigate('configuracoes/perfil')}>
                    <ListItemIcon>
                        <PersonOutlined fontSize="small" />
                    </ListItemIcon>
                    Perfil
                </MenuItem>
                <MenuItem
                    onClick={() => {
                        LogOut();
                        navigate('/', { replace: true });
                    }}
                >
                    <ListItemIcon>
                        <LogoutOutlined fontSize="small" />
                    </ListItemIcon>
                    Sair
                </MenuItem>
                <Divider sx={{ opacity: 0.35, my: 0.25 }} />
                <MenuItem
                    dense
                    disabled
                    tabIndex={-1}
                    sx={{
                        justifyContent: 'center',
                        py: 0.75,
                        minHeight: 0,
                        opacity: 1,
                        '&.Mui-disabled': { opacity: 1 },
                    }}
                >
                    <Typography variant="caption" sx={{ color: 'text.secondary', fontSize: '0.68rem', opacity: 0.55 }}>
                        Version : 4.0.5
                    </Typography>
                </MenuItem>
            </Menu>
        </Dropdown>
    );
}

function NavLink({ item, pathname, onNavigate }) {
    const selected = isNavActive(pathname, item);
    const Icon = item.icon;
    return (
        <ListItemButton
            component={Link}
            to={item.to}
            selected={selected}
            onClick={onNavigate}
            sx={{
                mx: 1,
                borderRadius: 1.5,
                '&.Mui-selected': {
                    bgcolor: theme => alpha(theme.palette.primary.main, 0.1),
                    color: 'primary.main',
                    '&:hover': { bgcolor: theme => alpha(theme.palette.primary.main, 0.16) },
                    '& .MuiListItemIcon-root': { color: 'inherit' },
                    '& .MuiListItemText-primary': { color: 'inherit', fontWeight: 700 },
                },
            }}
        >
            {Icon ? (
                <ListItemIcon sx={{ minWidth: 28, color: selected ? 'inherit' : 'text.secondary' }}>
                    <Icon fontSize="small" />
                </ListItemIcon>
            ) : null}
            <ListItemText
                primary={item.label}
                primaryTypographyProps={{ fontWeight: selected ? 700 : 600 }}
            />
        </ListItemButton>
    );
}

function SidebarNav({ pathname, onNavigate }) {
    return (
        <List disablePadding sx={{ py: 1.5 }}>
            <NavLink item={DASHBOARD_ITEM} pathname={pathname} onNavigate={onNavigate} />
            {NAV_GROUPS.map(group => (
                <Box key={group.label}>
                    <Divider sx={{ my: 1.5, mx: 1.5 }} />
                    <ListSubheader
                        disableSticky
                        sx={{
                            lineHeight: 2.2,
                            fontWeight: 700,
                            color: 'text.secondary',
                            bgcolor: 'transparent',
                        }}
                    >
                        {group.label}
                    </ListSubheader>
                    {group.items.map(item => (
                        <NavLink key={item.to} item={item} pathname={pathname} onNavigate={onNavigate} />
                    ))}
                </Box>
            ))}
        </List>
    );
}

function SidebarBody({ pathname, onNavigate }) {
    return (
        <Box sx={{ display: 'flex', flexDirection: 'column', height: '100%', pt: 1 }}>
            <Box sx={{ flex: 1, overflowY: 'auto' }}>
                <SidebarNav pathname={pathname} onNavigate={onNavigate} />
            </Box>
        </Box>
    );
}

export default function AdmProtected() {
    const navigate = useNavigate();
    const { pathname } = useLocation();
    const { LogOut, authenticated, authReady, user: authUser } = useAuth();
    const user = authUser || getStoredUser();

    const isMobile = useMediaQuery('(max-width:900px)');
    const [mobileOpen, setMobileOpen] = useState(false);

    if (!authReady || (authenticated && !user && !getStoredUser())) {
        return <LoadingContent />;
    }

    if (!authenticated) {
        return <Navigate to="/" replace />;
    }

    if (!isAdminUser(user)) {
        return <Navigate to="/" replace />;
    }

    const closeMobile = () => setMobileOpen(false);

    return (
        <HelpSidebarProvider>
            <AppBar
                position="fixed"
                elevation={0}
                sx={{
                    zIndex: theme => theme.zIndex.appBar,
                    borderBottom: 1,
                    borderColor: 'primary.dark',
                }}
            >
                <Toolbar>
                    {isMobile && (
                        <IconButton color="inherit" edge="start" onClick={() => setMobileOpen(true)} sx={{ mr: 1 }}>
                            <MenuIcon />
                        </IconButton>
                    )}
                    <Box component="img" src={Logo} width={130} height="auto" alt="Eurobem" sx={{ mr: 2 }} />
                    <Box sx={{ ml: 'auto' }}>
                        <UserMenu user={user} navigate={navigate} LogOut={LogOut} />
                    </Box>
                </Toolbar>
            </AppBar>

            <Drawer
                variant={isMobile ? 'temporary' : 'permanent'}
                open={isMobile ? mobileOpen : true}
                onClose={closeMobile}
                ModalProps={{ keepMounted: true }}
                sx={{
                    width: DRAWER_WIDTH,
                    flexShrink: 0,
                    '& .MuiDrawer-paper': {
                        width: DRAWER_WIDTH,
                        boxSizing: 'border-box',
                        top: isMobile ? 0 : 64,
                        height: isMobile ? '100%' : 'calc(100% - 64px)',
                        zIndex: theme => theme.zIndex.appBar - 1,
                        borderRight: '1px solid',
                        borderColor: 'divider',
                        bgcolor: 'background.paper',
                    },
                }}
            >
                <SidebarBody pathname={pathname} onNavigate={isMobile ? closeMobile : undefined} />
            </Drawer>

            <Box
                component="main"
                sx={{
                    minHeight: '100vh',
                    bgcolor: 'background.default',
                    ml: isMobile ? 0 : `${DRAWER_WIDTH}px`,
                    pt: theme => `calc(64px + ${theme.spacing(3)})`,
                    pb: 3,
                }}
            >
                <Outlet />
            </Box>
        </HelpSidebarProvider>
    );
}
